import type { SxProps } from '@mui/material';
import { Box, Divider } from '@mui/material';
import type { ReactNode } from 'react';
import { Button } from '../Button/Button';
import { Loader } from '../Loader/Loader';

interface Props {
  sx?: SxProps;
  slotProps?: {
    controls?: {
      sx?: SxProps;
    };
    actions?: {
      saveButtonText?: string;
    };
  };
  loading: boolean;
  title: string;
  controlsSlot: ReactNode;
  errorMessage?: ReactNode;
  saveDisabled?: boolean;
  onClose: () => void;
  onSave: () => void;
}

export function DataRecordEditor({
  sx,
  slotProps,
  loading,
  title,
  controlsSlot,
  errorMessage,
  saveDisabled,
  onClose,
  onSave,
}: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        border: '1px solid #DDDFE7',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <Box sx={{ p: 2, fontSize: '1.125rem', fontWeight: 500 }}>{title}</Box>
      <Divider />
      <Box sx={{ p: 2, display: 'flex', gap: 2, ...slotProps?.controls?.sx }}>
        {controlsSlot}
      </Box>
      <Divider />
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          disabled={saveDisabled}
          sx={{ borderRadius: 2, height: 40 }}
          onClick={onSave}
        >
          {slotProps?.actions?.saveButtonText || 'Save'}
        </Button>
        <Button
          sx={{ borderRadius: 2, height: 40 }}
          color="secondary"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
        {errorMessage}
      </Box>
      <Loader active={loading} />
    </Box>
  );
}
